import { render, staticRenderFns } from "./RatingInput.vue?vue&type=template&id=9ffcb218&"
import script from "./RatingInput.vue?vue&type=script&lang=js&"
export * from "./RatingInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports